<template>
  <div class="mt-2 mb-4">
    <v-btn color="red-darken-4" variant="elevated" elevation="0" @click="show_confirm_delete = true">Supprimer
      l'inscription</v-btn>
    <v-dialog v-model="show_confirm_delete" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div>
            Son inscription au parcours, ses options et son dossard seront liberés. Si un paiement a eu lieu pour cette
            inscription, aucun remboursement ne sera effectué. Pour procéder à un remboursement, veuillez naviguer dans
            l'onglet
            'remboursements'
          </div>
          <div class="text-body-1">Voulez-vous vraiment <b>supprimer</b> ce participant ?</div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red-darken-4" @click="show_confirm_delete = false">Non</v-btn>
          <v-btn color="green-darken-4" @click="handle_delete">Oui</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdminService from "@/services/admin.service.js";
export default {
  props: ["id_inscription"],
  data() {
    return {
      show_confirm_delete: false,
    };
  },
  methods: {
    async handle_delete() {
      this.show_confirm_delete = false;
      let request = await AdminService.deleteInscription(this.id_inscription);
      if (!request.error) {
        this.$emit("delete_inscription");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>